import { render, staticRenderFns } from "./ExpenseList.vue?vue&type=template&id=5c88c2a4&scoped=true"
import script from "./ExpenseList.vue?vue&type=script&lang=js"
export * from "./ExpenseList.vue?vue&type=script&lang=js"
import style0 from "./ExpenseList.vue?vue&type=style&index=0&id=5c88c2a4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c88c2a4",
  null
  
)

export default component.exports